{
  "id": "campaign-159",
  "name": "Unkempt Pasture",
  "seed": "campaign:159",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,,,,,,,k,,,...,,,",
    ",,,,,,,,,,,,...,,,",
    ",,,Y,,,,,,,,,,,,,,",
    ",,,,,,,,,,,,,,,,,,",
    ",,,,,,,,,,,,,,,,,,",
    ",,,,,,,,,,,,,,,,,,",
    ",,,,,,,,,,,,T,,,,k",
    ",,,,,,,,,,,,,,,,,,",
    "k,,,,,,,x,,,T,,,,,",
    ",,,,,,,,,,,,,,,,,,",
    ",,......,,,,,,,,,,",
    ",........#,h,,,.,,",
    ",........,,,,,,,,,",
    ",........,,,,,,Y,,",
    ",,.....h,T..,,,,,,",
    ",,,,,,,,.....,,,,,",
    ",,h,,,T,.....,,,,,",
    ",,,,,,,,.....,...S"
  ],
  "critters": [
    {
      "kind": "deer",
      "x": 7,
      "y": 10
    },
    {
      "kind": "deer",
      "x": 7,
      "y": 11
    },
    {
      "kind": "fox",
      "x": 8,
      "y": 15
    },
    {
      "kind": "fox",
      "x": 3,
      "y": 11
    },
    {
      "kind": "deer",
      "x": 11,
      "y": 14
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 7,
      "y": 5
    },
    {
      "kind": "gas",
      "x": 17,
      "y": 15
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 16
    },
    {
      "kind": "gas",
      "x": 16,
      "y": 0
    },
    {
      "kind": "gas",
      "x": 13,
      "y": 4
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 4
    },
    {
      "kind": "gas",
      "x": 13,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 17,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 15,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 3
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "hills": [
    {
      "x": 0,
      "y": 12,
      "w": 3,
      "h": 3
    },
    {
      "x": 7,
      "y": 8,
      "w": 5,
      "h": 5
    }
  ],
  "generatorVersion": 3,
  "level": 159,
  "biome": "meadow",
  "par": {
    "reel": 13002,
    "push": 11334,
    "selfPropelled": 10254,
    "tractor": 9072,
    "zeroTurn": 7808,
    "fairway": 4251
  },
  "goldTime": {
    "reel": 13002,
    "push": 11334,
    "selfPropelled": 10254,
    "tractor": 8848,
    "zeroTurn": 7575,
    "fairway": 3789
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 11,
      "zeroTurn": 13,
      "fairway": 22
    },
    "gold": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 25,
      "zeroTurn": 30,
      "fairway": 31
    }
  }
}
